import { useContext } from 'react';
import { MenuRouteContext } from '../../MenuRouteContainer/context/MenuRouteContext';

const useMenuRoute = () => {
  const { currentMenuRoute, push, goBack, history } = useContext(MenuRouteContext);

  return { currentMenuRoute, push, goBack, history };
};

export default useMenuRoute;
